/* ciúb delivery dates: one set of rules for the product page, collection cards, gifts page and cart.
   Orders placed before the 6am (UK time) cutoff count for that day; after it, for the next day.
   Arrives = that day + the market's days. No Sunday deliveries (moves to Monday).
   "Order within" counts down to the last cutoff that still gives the same arrival date. */
(function () {
  if (window.ciubEta) return;
  var RULES = {
    GB: { days: 2 }, IM: { days: 3 }, IE: { days: 3 },
    US: { days: 4 }, NL: { days: 4 },          // 3–5 days: shows the middle date
    DE: { days: 5 }, DEFAULT: { days: 5 }      // 3–7 days: shows the middle date
  };
  var CUTOFF_HOUR = 6, HOUR = 36e5, DAY = 864e5;

  // the time in London, as a UTC timestamp (so dates and hours can be read with getUTC*)
  function wallNow(now) {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
      .formatToParts(now).reduce(function (o, x) { o[x.type] = x.value; return o; }, {});
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
  }
  function arrival(cutoff, days) {
    var a = new Date(cutoff - CUTOFF_HOUR * HOUR + days * DAY);
    if (a.getUTCDay() === 0) a = new Date(a.getTime() + DAY);
    return a;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '');
  }
  function get(country, now) {
    var rule = RULES[country] || RULES.DEFAULT;
    var w = wallNow(now || new Date());
    var cut = Math.floor(w / DAY) * DAY + CUTOFF_HOUR * HOUR;
    if (w >= cut) cut += DAY;
    var a = arrival(cut, rule.days), last = cut;
    for (var i = 0; i < 7 && arrival(last + DAY, rule.days).getTime() === a.getTime(); i++) last += DAY;
    return { date: a, text: fmt(a), label: 'Arrives by ' + fmt(a), left: last - w };
  }
  function left(ms) {
    var m = Math.max(1, Math.ceil(ms / 6e4)), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    return d ? d + 'd ' + h + 'h ' + mm + 'm' : h ? h + 'h ' + mm + 'm' : mm + 'm';
  }
  window.ciubEta = { get: get, left: left, rules: RULES };
  document.dispatchEvent(new CustomEvent('ciub:eta-ready'));
})();
